import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutBrowsersPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutBrowsersPage({
  onNavigate
}: CheckoutBrowsersPageProps) {
  return <DocPageLayout title="Supported Browsers and Platforms" data-id="element-1098">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1099">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1100">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1101">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Supported Browsers and Platforms
      </div>

      <p className="text-gray-700 mb-6" data-id="element-1102">
        The hosted payment page is designed to work across all modern browsers
        and platforms, providing a consistent payment experience for your
        customers.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1103">
        Desktop Browsers
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-1104">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1105">
          <thead data-id="element-1106">
            <tr className="bg-gray-50" data-id="element-1107">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1108">
                Browser
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1109">
                Minimum Version
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1110">
                Lightbox
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1111">
                Payment Page
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1112">
            <tr data-id="element-1113">
              <td className="px-4 py-3" data-id="element-1114">Google Chrome</td>
              <td className="px-4 py-3" data-id="element-1115">60+</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1116">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1117">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1118">
              <td className="px-4 py-3" data-id="element-1119">Mozilla Firefox</td>
              <td className="px-4 py-3" data-id="element-1120">55+</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1121">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1122">✓</td>
            </tr>
            <tr data-id="element-1123">
              <td className="px-4 py-3" data-id="element-1124">Apple Safari</td>
              <td className="px-4 py-3" data-id="element-1125">11+</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1126">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1127">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1128">
              <td className="px-4 py-3" data-id="element-1129">Microsoft Edge</td>
              <td className="px-4 py-3" data-id="element-1130">79+</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1131">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1132">✓</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1133">
        Mobile Browsers
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-1134">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1135">
          <thead data-id="element-1136">
            <tr className="bg-gray-50" data-id="element-1137">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1138">
                Platform
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1139">
                Browser
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1140">
                Support
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1141">
            <tr data-id="element-1142">
              <td className="px-4 py-3" data-id="element-1143">iOS</td>
              <td className="px-4 py-3" data-id="element-1144">Safari</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1145">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1146">
              <td className="px-4 py-3" data-id="element-1147">iOS</td>
              <td className="px-4 py-3" data-id="element-1148">Chrome</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1149">✓</td>
            </tr>
            <tr data-id="element-1150">
              <td className="px-4 py-3" data-id="element-1151">Android</td>
              <td className="px-4 py-3" data-id="element-1152">Chrome</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1153">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1154">
              <td className="px-4 py-3" data-id="element-1155">Android</td>
              <td className="px-4 py-3" data-id="element-1156">Samsung Internet</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1157">✓</td>
            </tr>
          </tbody>
        </table>
      </div>

      <InfoBox type="info" title="Internet Explorer" data-id="element-1158">
        Internet Explorer is not supported. Users on IE will be prompted to
        upgrade to a modern browser.
      </InfoBox>
    </DocPageLayout>;
}